export const REWARD_PROMPT_COOLDOWN_MS = 24 * 60 * 60 * 1000;

export const LEADERBOARD_REWARD_IDS = ["leaderboard_top10", "leaderboard_top3", "leaderboard_rank1"];

const quest = (id, labelKey, category, statPath, target, coins, iconType, extra = {}) => ({
  id, labelKey, category, statPath, target, coins, iconType, ...extra,
});

export const QUEST_REWARD_SPECS = [
  quest("first_match_played", "firstMatchPlayed", "matches", ["stats", "overall", "played"], 1, 10, "single"),
  quest("matches_5", "matches5", "matches", ["stats", "overall", "played"], 5, 15, "single"),
  quest("matches_10", "matches10", "matches", ["stats", "overall", "played"], 10, 20, "single"),
  quest("matches_20", "matches20", "matches", ["stats", "overall", "played"], 20, 25, "single"),
  quest("matches_50", "matches50", "matches", ["stats", "overall", "played"], 50, 50, "single"),
  quest("matches_100", "matches100", "matches", ["stats", "overall", "played"], 100, 75, "single"),
  quest("first_tournament_played", "firstTournamentPlayed", "tournaments", ["stats", "tournaments", "tournamentsPlayed"], 1, 15, "trophy"),
  quest("tournaments_10_played", "tournaments10Played", "tournaments", ["stats", "tournaments", "tournamentsPlayed"], 10, 50, "trophy"),
  quest("first_tournament_won", "firstTournamentWon", "tournaments", ["stats", "tournaments", "tournamentsWon"], 1, 25, "trophy"),
  quest("tournaments_5_won", "tournaments5Won", "tournaments", ["stats", "tournaments", "tournamentsWon"], 5, 50, "trophy"),
  quest("tournaments_10_won", "tournaments10Won", "tournaments", ["stats", "tournaments", "tournamentsWon"], 10, 75, "trophy"),
  quest("tournaments_25_won", "tournaments25Won", "tournaments", ["stats", "tournaments", "tournamentsWon"], 25, 150, "trophy"),
  quest("evening_cups_5", "eveningCups5", "tournamentTypes", ["stats", "quests", "tournamentTypes", "evening"], 5, 30, "trophy"),
  quest("nightly_cups_5", "nightlyCups5", "tournamentTypes", ["stats", "quests", "tournamentTypes", "nightly"], 5, 30, "trophy"),
  quest("special_cups_1", "specialCups1", "tournamentTypes", ["stats", "quests", "tournamentTypes", "special"], 1, 15, "trophy"),
  quest("special_cups_5", "specialCups5", "tournamentTypes", ["stats", "quests", "tournamentTypes", "special"], 5, 25, "trophy"),
  quest("creator_cups_3", "creatorCups3", "tournamentTypes", ["stats", "quests", "tournamentTypes", "creator"], 3, 40, "trophy"),
  quest("wins_1", "wins1", "wins", ["stats", "overall", "wins"], 1, 10, "fire"),
  quest("wins_10", "wins10", "wins", ["stats", "overall", "wins"], 10, 25, "fire"),
  quest("wins_20", "wins20", "wins", ["stats", "overall", "wins"], 20, 35, "fire"),
  quest("wins_50", "wins50", "wins", ["stats", "overall", "wins"], 50, 60, "fire"),
  quest("wins_100", "wins100", "wins", ["stats", "overall", "wins"], 100, 100, "fire"),
  quest("win_streak_3", "winStreak3", "wins", ["stats", "quests", "maxWinStreak"], 3, 30, "fire"),
  quest("win_streak_5", "winStreak5", "wins", ["stats", "quests", "maxWinStreak"], 5, 60, "fire"),
  quest("friend_1", "friend1", "community", null, 1, 10, "community", { statKey: "friendCount" }),
  quest("friends_5", "friends5", "community", null, 5, 20, "community", { statKey: "friendCount" }),
  quest("friends_10", "friends10", "community", null, 10, 30, "community", { statKey: "friendCount" }),
  quest("friends_20", "friends20", "community", null, 20, 50, "community", { statKey: "friendCount" }),
  quest("coins_1000_single", "coins1000Single", "achievements", ["stats", "single", "coinsEarned"], 1000, 25, "coin"),
  quest("coins_5000_single", "coins5000Single", "achievements", ["stats", "single", "coinsEarned"], 5000, 50, "coin"),
  quest("coins_10000_single", "coins10000Single", "achievements", ["stats", "single", "coinsEarned"], 10000, 75, "coin"),
  quest("login_3_days", "login3Days", "loyalty", ["dailyBonusStreak"], 3, 10, "calendar"),
  quest("login_10_days", "login10Days", "loyalty", ["dailyBonusStreak"], 10, 25, "calendar"),
  quest("login_25_days", "login25Days", "loyalty", ["dailyBonusStreak"], 25, 50, "calendar"),
  quest("leaderboard_top10", "leaderboardTop10", "leaderboard", null, 1, 15, "crown", { leaderboardRankMax: 10 }),
  quest("leaderboard_top3", "leaderboardTop3", "leaderboard", null, 1, 25, "crown", { leaderboardRankMax: 3 }),
  quest("leaderboard_rank1", "leaderboardRank1", "leaderboard", null, 1, 50, "crown", { leaderboardRankExact: 1 }),
  quest("leaderboard_top10_months_3", "leaderboardTop10Months3", "leaderboard", ["stats", "quests", "leaderboard", "top10Months"], 3, 50, "crown"),
  quest("leaderboard_top3_months_3", "leaderboardTop3Months3", "leaderboard", ["stats", "quests", "leaderboard", "top3Months"], 3, 75, "crown"),
  quest("leaderboard_rank1_months_3", "leaderboardRank1Months3", "leaderboard", ["stats", "quests", "leaderboard", "rank1Months"], 3, 150, "crown"),
  quest("goals_10", "goals10", "performance", ["stats", "quests", "goalsScored"], 10, 10, "goal"),
  quest("goals_25", "goals25", "performance", ["stats", "quests", "goalsScored"], 25, 20, "goal"),
  quest("goals_50", "goals50", "performance", ["stats", "quests", "goalsScored"], 50, 30, "goal"),
  quest("goals_100", "goals100", "performance", ["stats", "quests", "goalsScored"], 100, 50, "goal"),
  quest("dominant_win", "dominantWin", "performance", ["stats", "quests", "dominantWins"], 1, 20, "goal"),
  quest("clean_sheet_win", "cleanSheetWin", "performance", ["stats", "quests", "cleanSheetWins"], 1, 20, "goal"),
];

export function getPreviousMonthKey(date = new Date()) {
  const d = new Date(date);
  d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function getEffectiveQuestRewardClaimId(rewardId, date = new Date()) {
  return LEADERBOARD_REWARD_IDS.includes(rewardId) ? `${rewardId}_${getPreviousMonthKey(date)}` : rewardId;
}

function readPath(source, path = []) {
  return path.reduce((value, key) => (value && value[key] !== undefined ? value[key] : undefined), source);
}

function getLeaderboardProgress(userData = {}, spec, date = new Date()) {
  const rank = Number(readPath(userData, ["stats", "leaderboard", "finalMonthlyRank"]) || 0);
  const month = String(readPath(userData, ["stats", "leaderboard", "finalMonthlyRankMonth"]) || "");
  if (month !== getPreviousMonthKey(date) || rank <= 0) return 0;
  if (spec.leaderboardRankExact) return rank === spec.leaderboardRankExact ? 1 : 0;
  return spec.leaderboardRankMax && rank <= spec.leaderboardRankMax ? 1 : 0;
}

export function buildQuestRewards(userData = {}, options = {}) {
  const friendCount = Number(options.friendCount || 0);
  const date = options.date || new Date();
  return QUEST_REWARD_SPECS.map((spec) => {
    const rawProgress = LEADERBOARD_REWARD_IDS.includes(spec.id)
      ? getLeaderboardProgress(userData, spec, date)
      : spec.statKey === "friendCount" ? friendCount : readPath(userData, spec.statPath);
    return { ...spec, progress: Number(rawProgress || 0), supported: true, claimId: getEffectiveQuestRewardClaimId(spec.id, date) };
  });
}

export function getUnclaimedCompletedQuestRewards(userData = {}, options = {}) {
  const claimed = Array.isArray(userData?.claimedRewardIds) ? userData.claimedRewardIds : [];
  return buildQuestRewards(userData, options).filter((reward) => reward.progress >= reward.target && !claimed.includes(reward.claimId));
}

export function getQuestRewardPromptSignature(rewards = []) {
  return rewards.map((reward) => reward.claimId || reward.id).sort().join("|");
}

export function timestampToMillis(value) {
  if (!value) return 0;
  if (typeof value?.toMillis === "function") return value.toMillis();
  if (typeof value?.toDate === "function") return value.toDate().getTime();
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }
  return 0;
}

export function shouldShowQuestRewardPrompt(userData = {}, options = {}) {
  const nowMs = typeof options.nowMs === "number" ? options.nowMs : Date.now();
  const rewards = getUnclaimedCompletedQuestRewards(userData, options);
  const signature = getQuestRewardPromptSignature(rewards);
  if (!signature) return { shouldShow: false, rewards, signature };
  const promptState = userData?.engagementPrompts?.questRewards || {};
  const lastShownAtMs = timestampToMillis(promptState.lastShownAt);
  return {
    shouldShow: !lastShownAtMs || nowMs - lastShownAtMs >= REWARD_PROMPT_COOLDOWN_MS,
    rewards,
    signature,
  };
}
